<template>
  <el-container id="home">
    <el-header>
      <el-col :lg="8"
              :md="7"
              :sm="6"
              :xl="6"
              :xs="6"
              class="logo clear">
        <a href="http://www.tianxia120.com/#/home"
           target="_blank">
          <img alt=""
               src="../../static/assets/logo2.png"><span>天下医生</span>
        </a>
        <a>|</a>
        <a href="https://app.tianxia120.com/member/#/"
           target="_blank">
          <img alt=""
               src="../../static/assets/logo@1x.png"><span>会员管家</span>
        </a>
      </el-col>
      <el-col :xl="18"
              :xs="18"
              class="mobile">
        <a @click="join">申请加入</a>
        <span @click="sidebar=1"><img src="../../static/assets/hot.png"></span>
      </el-col>
      <el-col :lg="16"
              :md="17"
              :sm="18"
              :xl="18"
              :xs="18"
              class="nav">
        <el-menu :default-active="activeIndex"
                 @select="handleSelect"
                 class="el-menu-demo"
                 mode="horizontal">
          <el-menu-item :class="index1"
                        index="1"><a href="#carousel">首页</a></el-menu-item>
          <el-menu-item :class="index2"
                        index="2"><a href="#function">功能介绍</a></el-menu-item>
          <el-menu-item :class="index3"
                        index="3"><a href="#solve">解决方案</a></el-menu-item>
          <el-menu-item :class="index4"
                        index="4"><a @click="centerDialogVisible = true"
               href="#carousel">申请加入</a>
          </el-menu-item>
          <el-menu-item :class="index5"
                        index="5"><a href="#mainer">关于我们</a></el-menu-item>
        </el-menu>
      </el-col>
    </el-header>
    <sidebar v-if="sidebar==1"
             :sidebar="sidebar"
             :showMain="showMain"
             v-on:childByValue="childByValue"></sidebar>
    <el-main id="carousel"
             v-if="showMain">
      <carousel></carousel>
      <functions :classdate='classdate'></functions>
      <solve :classsolve='classsolve'></solve>
    </el-main>
    <mainer v-else
            :mainer="mainer"></mainer>
    <el-footer>
      <h3>会员管家，是「天下医生」自主研发的、以智能医学物联网和边缘计算架构为应用基础的SaaS健康数字化解决方案系统</h3>
      <ul class="clear">
        <li :key="i"
            v-for="(item,i) in footlist"><img :src="item.src">{{item.name}}</li>
      </ul>
      <p>Copyright © 成都天下医森数字科技有限公司 <a href="http://beian.miit.gov.cn"
           target="_blank"
           style="display: inline-block;color: #FFFFFF">蜀ICP备17001604号-1</a>
      </p>

    </el-footer>
    <el-dialog :visible.sync="centerDialogVisible"
               center
               title="会员管家申请"
               :before-close="closeDialog">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="109px"
               class="demo-ruleForm">
        <el-form-item label="手机号码:"
                      prop="tell">
          <el-input v-model="ruleForm.tell"
                    placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="验证码:"
                      prop="code">
          <el-input v-model="ruleForm.code"
                    placeholder="请输入验证码"
                    clearable></el-input>
          <a :class="verifications"
             @click="getverification()">{{ruleForm.codename}}</a>
        </el-form-item>
        <el-form-item label="姓名:"
                      prop="name">
          <el-input v-model="ruleForm.name"
                    placeholder="请输入姓名"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="职务:"
                      prop="post">
          <el-input v-model="ruleForm.post"
                    placeholder="请输入职务"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="邮箱:"
                      prop="mailbox">
          <el-input v-model="ruleForm.mailbox"
                    placeholder="请输入邮箱"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="网点名称:"
                      prop="institution">
          <el-input v-model="ruleForm.institution"
                    placeholder="请输入机构名称"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="网点电话:"
                      prop="phone">
          <el-input v-model="ruleForm.phone"
                    placeholder="请填写用于顾客咨询的座机或手机号码"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="地址:"
                      prop="address">
          <el-cascader :options="options"
                       :show-all-levels="true"
                       v-model="ruleForm.address"
                       @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="详情地址:"
                      prop="detailaddress">
          <el-tag v-if="textarea[0]?true:false">{{textarea[0]}}</el-tag>
          <el-tag v-if="textarea[1]?true:false">{{textarea[1]}}</el-tag>
          <el-tag v-if="textarea[2]?true:false">{{textarea[2]}}</el-tag>
          <el-input placeholder="请输入详情地址"
                    v-model="ruleForm.detailaddress"></el-input>
        </el-form-item>
        <el-form-item label="上传LOGO:"
                      prop="logo">
          <el-upload :action="imageUploadURL"
                     :before-upload="beforeAvatarUpload"
                     :on-success="handleLOGOSuccess"
                     :on-remove="handleRemove"
                     ref='upload1'
                     :show-file-list="true"
                     class="avatar-uploader"
                     list-type="picture-card"
                     v-model="ruleForm.logo">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="上传证明:"
                      prop="License">
          <el-upload :action="imageUploadURL"
                     :before-upload="beforeAvatarUpload"
                     :on-success="handleAvatarSuccess"
                     :on-remove="handleRemove1"
                     ref='upload'
                     :show-file-list="true"
                     class="avatar-uploader"
                     list-type="picture-card"
                     v-model="ruleForm.License">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p>营业执照或许可证复印件(必须加盖公章)</p>
        </el-form-item>
        <el-form-item label=""
                      prop="authorize">
          <el-upload :action="imageUploadURL"
                     :before-upload="beforeAvatarUpload"
                     :on-success="handleProveSuccess"
                     :on-remove="handleRemove2"
                     ref='upload2'
                     :show-file-list="true"
                     class="avatar-uploader"
                     list-type="picture-card"
                     v-model="ruleForm.authorize">
            <i class="el-icon-plus"></i>
          </el-upload>
          <p><img src="../../static/assets/pdf.png"
                 style="width: 10px;height: 10px;margin-top: 3px;margin-right: 2px"><a href="https://app.tianxia120.com/cat/file/downloadPowerOfAttorney"
               style="color:#0270cf">下载标准授权委托书</a>，填写后打印盖章即可
          </p>
        </el-form-item>
        <el-form-item>
          <el-button type="上传证明:"
                     @click="submitForm('ruleForm')">提 交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible"
               id="successPrompt">
      <div class="success clear">
        <img src="../../static/assets/icon_zhengque@1x.png">
        <div class="prompt">
          <h3>提交成功!</h3>
          <p>我们将尽快审核，与您取得联系。</p>
        </div>
      </div>
    </el-dialog>
    <div id="successPrompt1"
         v-show="dialogVisible2">
      <div class='cuowu'>提交失败</div>
    </div>
  </el-container>
</template>
<script>
  import carousel from '../components/carousel'
  import functions from '../components/functions'
  import solve from '../components/solve'
  import mainer from '../components/mainer'
  import sidebar from '../components/sidebar'
  import { getcode, joinuserList, checkAddress } from '../api/user'

  export default {
    name: "home",
    data () {
      return {
        textarea: [], //省市县标签
        options: [], //省市县下拉列表
        activeIndex: '1',
        showMain: true,
        classdate: '',
        classsolve: '',
        baseUrl: '',
        footlist: [
          {
            name: '成都天下医森数字科技有限公司',
            src: require('../../static/assets/icon_home@1x.png')
          }, {
            name: '电话: 028- 85315618',
            src: require('../../static/assets/icon-hotline@1x.png')
          }, {
            name: '邮箱: kefu@tianxia120.com',
            src: require('../../static/assets/icon-mail@1x.png')
          }, {
            name: '地址:成都高新区天府大道中段530号',
            src: require('../../static/assets/icon-local@1x.png')
          }],
        ruleForm: {
          tell: '',
          code: '',
          codename: '获取验证码',
          name: '',
          post: '',
          mailbox: '',
          institution: '',
          phone: "",
          logo: [],
          License: [],
          authorize: [],
          address: [],
          detailaddress: ''
        },
        rules: {
          tell: [
            { required: true, pattern: /0?(13|14|15|18|17)[0-9]{9}/, message: '请输入正确的电话号码', trigger: 'blur' },
          ],
          code: [
            { required: true, pattern: /[0-9]{6}/, message: '请输入正确的验证码', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          post: [
            { required: true, message: '请输入职务', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
          ],
          mailbox: [
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
          ],
          institution: [
            { required: true, message: '请输入网点名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 15 个字符', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入网点电话', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 15 个字符', trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请选择省市县', trigger: 'blur' },
          ],
          detailaddress: [
            { required: true, message: '请选择详细地址', trigger: 'blur' }
          ],
          logo: [
            { required: true, message: '至少上传一张图片', trigger: 'blur' },
          ],
          License: [
            { required: true, message: '至少上传一张图片', trigger: 'blur' },
          ],
          authorize: [
            { required: true, message: '至少上传一张图片', trigger: 'blur' },
          ]
        },
        centerDialogVisible: false,
        imageUploadURL: "https://app.tianxia120.com/cat/hospitalManager/uploadImg",
        dialogVisible: false,
        dialogVisible2: false,
        dialogImageUrlList: [],
        verifications: 'verification',
        index1: '',
        index2: '',
        index3: '',
        index4: '',
        index5: '',
        clearTimeSet: {},
        sidebar: '',//移动端侧栏显示
        mainer: '',
        address: ''
      };
    },
    methods: {
      //地址省市县处理
      handleChange (value) {
        console.log(value);
        this.textarea = []
        this.options.forEach((item) => {
          if (item.value == value[0]) {
            this.textarea[0] = item.label
            item.children.forEach((city) => {
              if (city.value == value[1]) {
                this.textarea[1] = city.label
                if (city.children) {
                  city.children.forEach((area) => {
                    if (area.value == value[2]) {
                      this.textarea[2] = area.label
                    }
                  })
                }
              }
            })
          }
        })
        // console.log(this.textarea)
      },
      handleSelect (key) {
        if (key == 1) {
          this.showMain = true;
          this.classsolve = 'solve';
          this.classdate = '';
          this.index1 = 'background';
          this.index2 = this.index3 = this.index4 = this.index5 = ''
        } else if (key == 2) {
          this.showMain = true;
          this.classdate = 'margintop';
          this.classsolve = 'solve';
          this.index2 = 'background';
          this.index1 = this.index3 = this.index4 = this.index5 = ''
        } else if (key == 3) {
          this.showMain = true;
          this.classsolve = 'solve margintop';
          this.classdate = '';
          this.index3 = 'background';
          this.index1 = this.index2 = this.index4 = this.index5 = ''
        } else if (key == 4) {
          this.showMain = true;
          this.classsolve = 'solve';
          this.classdate = '';
          this.ruleForm.codename = '获取验证码';
          this.index4 = 'background';
          this.index2 = this.index3 = this.index1 = this.index5 = ''
        } else {
          this.showMain = false;
          this.classsolve = 'solve';
          this.classdate = '';
          this.index5 = 'background';
          this.index2 = this.index3 = this.index4 = this.index1 = ''
        }
      },

      // 获取验证码
      getverification () {
        if (this.ruleForm.tell != '' && (this.ruleForm.codename == '获取验证码' || this.ruleForm.codename == '重新获取')) {
          getcode({ 'loginName': '+86-' + this.ruleForm.tell }).then(({ data }) => {
            console.log(data, '短信')
            if (data.statusCode == 200) {
              this.setTime()
            }
          });
        }
      },
      //设置定时器
      setTime () {
        this.ruleForm.codename = '90s'
        this.verifications = 'verification color';
        let i = 89;
        this.clearTimeSet = setInterval(() => {
          if (i >= 0) {
            this.verifications = 'verification color';
            this.ruleForm.codename = i + 's'
          } else if (i < 0) {
            this.verifications = 'verification';
            this.clearTime()
          }
          i--;
        }, 1000);
      },
      //清除定时器
      clearTime () {
        this.ruleForm.codename = '重新获取';
        this.verifications = 'verification';
        this.ruleForm.address = this.textarea = [];
        this.ruleForm.detailaddress = this.address = ''
        clearInterval(this.clearTimeSet);
      },

      // 图片成功后处理
      handleLOGOSuccess (res) {
        this.ruleForm.logo.push(res.data)
      },
      handleAvatarSuccess (res) {
        this.ruleForm.License.push(res.data)
      },
      handleProveSuccess (res) {
        this.ruleForm.authorize.push(res.data)
      },
      //删除图片处理
      handleRemove (file, fileList) {
        this.ruleForm.logo.forEach((value, array) => {
          if (value == file.response.data) {
            array.splice(value, 1)
          }
        })
      },
      handleRemove1 (file, fileList) {
        this.ruleForm.License.forEach((value, array) => {
          if (value == file.response.data) {
            array.splice(value, 1)
          }
        })
      },
      handleRemove2 (file, fileList) {
        this.ruleForm.authorize.forEach((value, index, array) => {
          if (value == file.response.data) {
            array.splice(value, 1)
          }
        })
      },
      //上传文件之前
      beforeAvatarUpload (file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 10MB!');
        }
        return isLt2M;
      },

      // 提交处理
      submitForm (formName) {
        this.dialogImageUrlList = {
          'logoImg': this.ruleForm.logo,
          'license': this.ruleForm.License,
          'authorize': this.ruleForm.authorize
        }
        this.textarea.forEach((item) => {
          this.address = this.address + item
        })
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.centerDialogVisible = false;
            joinuserList({
              "phone": this.ruleForm.tell,
              "hotline": this.ruleForm.phone,
              "code": this.ruleForm.code,
              "name": this.ruleForm.name,
              "position": this.ruleForm.post,
              "email": this.ruleForm.mailbox,
              "orgName": this.ruleForm.institution,
              "provinceId": this.ruleForm.address[0],
              "cityId": this.ruleForm.address[1],
              "districtId": this.ruleForm.address[2],
              "address": this.address + this.ruleForm.detailaddress,
              "credentials": JSON.stringify(this.dialogImageUrlList)
            }).then(({ data }) => {
              if (data.statusCode == '200') {
                this.$refs[formName].resetFields();
                this.$refs.upload.clearFiles();//清除图片
                this.$refs.upload1.clearFiles()
                this.$refs.upload2.clearFiles();
                this.clearTime()
                this.ruleForm.logo = this.ruleForm.authorize = this.ruleForm.License = this.dialogImageUrlList = []
                this.centerDialogVisible = false;
                this.dialogVisible = true;
                setTimeout(() => {
                  this.dialogVisible = false
                }, 2000)
              } else {
                this.dialogVisible2 = true
                setTimeout(() => {
                  this.dialogVisible2 = false
                }, 2000)
              }
            })
          } else {
            return false;
          }
        });
      },
      closeDialog (done) {
        done();
        this.$router.push('/'); //跳转到指定页面
        this.clearTime();
        this.$refs.ruleForm.clearValidate();
        this.$refs.ruleForm.resetFields();
        this.$refs.upload.clearFiles();//清除图片
        this.$refs.upload1.clearFiles();
        this.$refs.upload2.clearFiles();
        this.ruleForm.logo = this.ruleForm.authorize = this.ruleForm.License = this.dialogImageUrlList = []
      },
      childByValue (data) {
        this.sidebar = '';
        if (data == 3) {
          this.showMain = false
          this.mainer = 3
        } else {
          this.showMain = true
          // this.$router.push({ path:'/carousel'})
        }
      },
      join () {
        this.$router.push({ path: '/aboutme' })
      }
    },
    mounted () {
      checkAddress({}).then(({ data }) => {
        // console.log(data.object)
        data.object.forEach((province) => {
          if (province.bAreaDtos && province.bAreaDtos.length > 0) {

            const children1 = province.bAreaDtos.map((city) => {

              if (city.bAreaDtos && city.bAreaDtos.length > 0) {

                const children = city.bAreaDtos.map((area) => {
                  return {
                    value: area.adcode,
                    label: area.name
                  }
                })
                return {
                  value: city.adcode,
                  label: city.name,
                  children
                }

              } else {
                return {
                  value: city.adcode,
                  label: city.name,
                }
              }
            })
            this.options.push({
              value: province.adcode,
              label: province.name,
              children: children1
            })

          } else {
            this.options.push({
              value: province.adcode,
              label: province.name
            })
          }
        })
      });
    },
    components: {
      carousel, functions, solve, mainer, sidebar
    }
  }
</script>

<style lang="less">
  /*---滚动条默认显示样式--*/
  ::-webkit-scrollbar-thumb {
    height: 50px;
    outline-offset: -2px;
    outline: 2px solid #fff;
    -webkit-border-radius: 4px;
    border: 2px solid #fff;
  }

  /*---鼠标点击滚动条显示样式--*/
  ::-webkit-scrollbar-thumb:hover {
    height: 50px;
    -webkit-border-radius: 4px;
  }

  /*---滚动条大小--*/
  ::-webkit-scrollbar {
    width: 10px;
    height: 8px;
  }

  /*---滚动框背景样式--*/
  ::-webkit-scrollbar-track-piece {
    -webkit-border-radius: 0;
  }
  ::-webkit-scrollbar-track {
    background-color: #eee;
  } /* 滚动条的滑轨背景颜色 */
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  } /* 滑块颜色 */
  ::-webkit-scrollbar-button {
    background-color: #eee;
  } /* 滑轨两头的监听按钮颜色 */
  ::-webkit-scrollbar-corner {
    background-color: black;
  } /* 横向滚动条和纵向滚动条相交处尖角的颜色 */
  .el-popup-parent--hidden {
    padding-right: 0 !important;
  }
  .clear:after {
    content: ' ';
    clear: both;
    display: block;
    height: 0;
    visibility: hidden;
  }

  .el-form-item__error {
    width: 120px;
  }

  .el-cascader-menu {
    min-width: 120px;
  }

  .el-cascader__dropdown {
    left: 400px;
  }

  .el-cascader-node {
    padding: 0 10px 0 15px;
  }

  .el-textarea textarea {
    border-top: 0;
  }

  @media only screen and (max-width: 1920px) {
    #home {
      .el-header {
        width: 100%;
        height: 80px !important;
        padding: 0 240px !important;
        position: fixed;
        z-index: 100;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        .logo span,
        .nav .el-menu--horizontal > .el-menu-item {
          color: #333;
        }
        .logo {
          height: 100%;

          a {
            float: left;
            font-size: 30px;
            color: #999;
            line-height: 80px;

            img {
              vertical-align: middle;
            }

            span {
              display: inline-block;
              height: 80px;
              line-height: 80px;
              font-size: 20px;
            }
          }

          a:first-of-type img {
            width: 44px;
            height: 44px;
            margin: 18px 5px 18px 0;
          }

          a:nth-of-type(2) {
            margin: 0 15px;
          }

          a:last-of-type img {
            width: 45px;
            height: 40px;
            margin: 20px 5px 20px 0;
          }
        }
        .nav {
          display: block;
          .el-menu--horizontal {
            float: right;
          }

          .el-menu-item:hover {
            background: rgba(84, 196, 197, 0.1);
            color: #54c4c5;
          }

          .background {
            background: rgba(84, 196, 197, 0.1) !important;
            color: #54c4c5 !important;
          }

          .el-menu.el-menu--horizontal {
            border-bottom: 0px;
          }

          .el-menu--horizontal > .el-menu-item.is-active,
          .el-menu--horizontal > .el-menu-item {
            border-bottom: 0px;
          }

          .el-menu--horizontal > .el-menu-item a {
            width: 100%;
            height: 100%;
            display: inline-block;
          }

          .el-menu--horizontal > .el-menu-item {
            width: 120px;
            height: 80px;
            line-height: 80px;
            font-size: 18px;
            padding: 0;
            box-sizing: content-box;
          }
        }
        .mobile {
          display: none;
        }
      }
      .el-main {
        padding: 0 !important;
      }
      .el-footer {
        width: 100%;
        height: 210px !important;
        background-color: #333333;

        h3 {
          margin: 45px 0 20px;
          color: #ffffff;
          font-size: 18px;
          font-weight: 500;
        }

        ul {
          width: 1200px;
          margin: 0 auto;

          li {
            float: left;
            width: 282px;
            color: #fff;
            font-size: 14px;
            line-height: 25px;
            text-align: left;

            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
              vertical-align: middle;
            }
          }
        }

        p {
          margin-top: 50px;
          margin-bottom: 10px;
          color: #fff;
          font-size: 14px;
        }
      }
      .el-dialog {
        margin-top: 9vh !important;
        width: 520px !important;
        .el-dialog__header {
          padding: 20px 20px 0;
          .el-dialog__headerbtn {
            font-size: 22px !important;
          }
        }
        .el-dialog__body {
          padding: 20px 25px 0 !important;
        }
        .el-form {
          width: 372px;
          margin: 0 auto;
        }
        .el-form-item {
          margin-bottom: 20px;
          display: inline-block;
          .el-form-item__content {
            .el-input {
              width: 265px;
              font-size: 16px;
            }
            input::-webkit-input-placeholder {
              font-size: 14px;
            }
            .verification {
              width: 70px;
              color: #fff;
              margin-left: 10px;
              padding: 10px 14px;
              border-radius: 4px;
              display: inline-block;
              text-align: center;
              cursor: pointer;
              background: linear-gradient(
                90deg,
                #53bba8,
                #00a1bc 58%,
                #0080c9
              ) !important;
            }
            .color {
              color: #9f9f9f;
              background: #eeeeee !important;
            }
          }
        }
        .avatar-uploader {
          margin-bottom: 1px;
          .el-upload-list {
            .el-icon-delete {
              color: #fff !important;
            }
          }
        }
        p {
          font-size: 12px !important;
        }
        .el-form-item__label {
          font-size: 16px;
          color: #333;
        }

        .el-form-item:nth-of-type(2) .el-input {
          width: 150.5px !important;
        }
        .el-upload--picture-card {
          line-height: 60px;
          .el-icon-plus {
            font-size: 20px;
          }
        }
        .el-form-item__content {
          line-height: 20px;
          color: #fff;
        }
        .el-upload--picture-card,
        .el-upload-list--picture-card .el-upload-list__item,
        .el-upload-list--picture-card .el-upload-list__item-actions {
          width: 60px;
          height: 60px;
        }
        .el-button {
          width: 152px;
          color: #fff;
          background: linear-gradient(
            90deg,
            #53bba8,
            #00a1bc 58%,
            #0080c9
          ) !important;
          span {
            color: #fff;
          }
        }
      }

      #successPrompt {
        margin: auto;
        margin-top: 25vh;

        .el-dialog__header {
          padding: 0;
        }

        .el-dialog {
          width: 480px !important;
        }

        .el-dialog__body {
          padding: 80px 36px 80px 49px !important;
        }

        .success {
          display: inline-block;

          img {
            float: left;
            width: 50px;
            height: 50px;
          }

          .prompt {
            float: left;
            padding-left: 15px;
          }

          h3 {
            text-align: left;
            color: #333333;
            font-size: 28px;
          }

          p {
            color: #333333;
            font-size: 22px !important;
          }
        }

        .el-icon-close:before {
          content: '';
        }
      }
      #successPrompt1 {
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        .cuowu {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #fff;
          width: 200px;
          height: 100px;
          line-height: 100px;
          border-radius: 5%;
          font-size: 20px;
        }
      }
    }
  }

  @media only screen and (max-width: 1400px) {
    #home {
      .el-header {
        height: 60px !important;
        padding: 0 110px !important;

        .logo {
          height: 100%;

          a {
            font-size: 17px;
            line-height: 60px;

            span {
              height: 60px;
              line-height: 60px;
              font-size: 16px;
            }
          }

          a:first-of-type img {
            width: 32px;
            height: 32px;
            margin: 14px 5px 14px 0;
          }

          a:nth-of-type(2) {
            margin: 0 5px;
          }

          a:last-of-type img {
            width: 32px;
            height: 30px;
            margin: 15px 5px 15px 0;
          }
        }

        .nav {
          .el-menu--horizontal > .el-menu-item {
            width: 100px;
            height: 60px;
            line-height: 60px;
            font-size: 16px;
          }
        }
      }
      .el-footer {
        h3 {
          font-size: 16px;
        }

        ul {
          width: 620px;

          li {
            width: 246px;
            font-size: 12px;
          }
        }

        p {
          margin-top: 40px;
          font-size: 12px;
        }
      }
      #successPrompt {
        .el-dialog {
          width: 480px !important;
        }

        .success {
          img {
            width: 50px;
            height: 50px;
          }

          .prompt {
            padding-left: 10px;
          }

          h3 {
            font-size: 20px !important;
          }

          p {
            color: #333333;
            font-size: 18px !important;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 992px) {
    #home {
      .el-header {
        padding: 0 60px !important;

        .logo {
          height: 100%;

          a {
            font-size: 17px;
            line-height: 60px;

            span {
              display: none;
            }
          }
        }

        .nav .el-menu--horizontal > .el-menu-item {
          width: 90px;
          font-size: 15px;
        }
      }
      .el-footer {
        h3 {
          font-size: 13px;
        }
      }
      #successPrompt {
        margin-top: 30vh;

        .el-dialog {
          width: 480px !important;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    #home {
      .el-header {
        padding: 0 5px !important;
        .logo {
          height: 100%;
          a:last-of-type img {
            width: 32px;
            height: 30px;
            margin: 15px 0;
          }
        }

        .nav .el-menu--horizontal > .el-menu-item {
          width: 60px;
          font-size: 13px;
        }
      }
      .el-footer {
        height: 270px !important;
        h3 {
          font-size: 12px;
          margin-top: 30px;
        }

        ul {
          width: 246px;
        }

        p {
          margin-top: 40px;
        }
      }
      .el-dialog {
        width: 350px !important;
        margin-top: 4vh !important;
      }
      .el-dialog .el-dialog__header {
        padding: 10px 20px 0;
      }
      .el-dialog--center .el-dialog__body {
        padding: 10px 20px 0 !important;
      }
      .el-dialog .el-form {
        width: 298px;
      }
      .el-dialog .el-form-item {
        margin-bottom: 10px;
      }
      .el-input {
        font-size: 12px;
      }
      .el-dialog .el-form-item:nth-of-type(2) .el-input {
        width: 130px !important;
      }
      .el-dialog .el-form-item__label {
        width: 84px !important;
        font-size: 12px;
      }
      .el-dialog .el-form-item .el-form-item__content .el-input {
        width: 214px;
      }
      .el-dialog .el-form-item .el-form-item__content .verification {
        font-size: 12px !important;
        width: 62px;
        padding: 10px 4px;
      }
      .el-form-item__content {
        font-size: 12px;
        margin-left: 84px !important;
      }
      .el-dialog .el-form-item__content p {
        font-size: 12px !important;
      }
      .el-dialog .el-upload--picture-card {
        line-height: 80px;
      }
      .el-dialog .el-upload--picture-card,
      .el-dialog .el-upload-list--picture-card .el-upload-list__item,
      .el-dialog .el-upload-list--picture-card .el-upload-list__item-actions {
        width: 80px;
        height: 80px;
      }
      #successPrompt {
        margin-top: 40vh;
        .el-dialog {
          width: 300px !important;
        }
        .el-dialog__body {
          padding: 40px 0 !important;
        }

        .success {
          img {
            width: 30px;
            height: 30px;
          }

          .prompt {
            padding-left: 10px;
          }

          h3 {
            font-size: 18px !important;
          }

          p {
            font-size: 14px !important;
          }
        }
      }
      .huawei-book {
        width: 300px;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    #home {
      .el-header {
        padding: 0 20px !important;
        a:nth-of-type(2) {
          display: none;
        }
        a:nth-of-type(3) {
          margin-left: 5px;
        }
        .nav {
          display: none;
        }
        .mobile {
          display: block;
          text-align: right;
          line-height: 60px;
          a {
            padding: 8px 15px;
            background: #24b4a2;
            border: none;
            color: #fff;
            margin-right: 20px;
            border-radius: 3px;
          }
          span {
            display: inline-block;
            width: 22px;
            height: 60px;
            img {
              width: 100%;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue